import { publicationIssueTarget } from './publicationPreflight';

export const useAgentWorkspaceNavigation = ({
  route,
  router,
  assistantId,
  workspaceSections,
  focusField,
}) => {
  const openRoute = routeName => {
    const params = { accountId: route.params.accountId };
    const isGlobalToolsRoute = routeName === 'captain_account_tools_index';
    if (routeName !== 'brand_voice_editor' && !isGlobalToolsRoute) {
      params.assistantId = assistantId.value;
    }
    const query = isGlobalToolsRoute
      ? {
          ...route.query,
          assistant_id: String(assistantId.value),
        }
      : undefined;
    return router.push({
      name: routeName,
      params,
      ...(query ? { query } : {}),
    });
  };

  const selectWorkspaceSection = async sectionId => {
    const workspaceItem = workspaceSections.value.find(
      item => item.id === sectionId
    );
    if (!workspaceItem) return false;

    if (workspaceItem.routeName) {
      await openRoute(workspaceItem.routeName);
      return true;
    }

    await router.push({
      name: 'captain_assistants_experience_index',
      params: {
        accountId: route.params.accountId,
        assistantId: assistantId.value,
      },
      query: { ...route.query, section: workspaceItem.id },
    });
    return true;
  };

  const reviewPublicationIssue = async issue => {
    const { section, fieldId } = publicationIssueTarget(issue);
    if (section === 'test') {
      await selectWorkspaceSection('test');
      return;
    }

    await selectWorkspaceSection(section);
    await focusField(fieldId);
  };

  return { openRoute, selectWorkspaceSection, reviewPublicationIssue };
};
